import ReactDOMServer from 'react-dom/server';
import PopUpAparcamiento from '@componentes/PopUp/PopUpAparcamiento'
import { formatHora } from './FormatDate';
import { ObtenerEstadoPilona } from './estadoPilona';
import PopUpCamara from '@componentes/PopUp/PopUpCamara';

function estaContenido(numero1, numero2, precision) {
    return Math.abs(numero2 - numero1) < precision;
}

const fetchImage = async (index, apiUrlConfig, instance) => {
    const apiUrl = `${apiUrlConfig}obtenerImagenCamaras/${index}`;
    try {
        const response = await instance.get(apiUrl, { responseType: 'arraybuffer' });
        const base64 = arrayBufferToBase64(response.data);
        return `data:image/jpeg;base64,${base64}`;
    } catch (error) {
        console.error("Error al hacer la solicitud:", error);
        return null;
    }
};

const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
};

export function mouseEnterMarker(map, nombre, isPanel, estado, width, popupContainer) {
    if (width > 1300) {
        map.getCanvas().style.cursor = 'pointer';
        let content = '';
        if (nombre) {
            if (isPanel) {
                content += `<h6 style="margin: 0;">Panel ${nombre} ${estado === 1 ? '(APAGADO)' : ''}</h6>`;
            } else {
                content += `<h6 style="margin: 0;">Señal ${nombre} ${estado === -1 ? '(APAGADA)' : ''}</h6>`;
            }
            popupContainer.innerHTML = content;
            popupContainer.style.display = 'block';
            popupContainer.style.backgroundColor = '#1f1f1f';
            popupContainer.style.color = 'white';
            popupContainer.style.borderRadius = '8px';
            popupContainer.style.padding = '10px';
            popupContainer.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.5)';
        }
    }
}

const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((value, index) => value === arr2[index]);
};

export function mouseEnter(e, map, coordinates, width, popupContainer, activeCoordinates) {
    if (width > 1300) {
        map.getCanvas().style.cursor = 'pointer';
        if (e.features && e.features.length > 0) {
            const feature = e.features[0];
            if (feature.geometry.type === 'Point' && Array.isArray(feature.geometry.coordinates)) {
                const coordinatesActual = feature.geometry.coordinates.slice();
                while (Math.abs(e.lngLat.lng - coordinatesActual[0]) > 180) {
                    coordinatesActual[0] += e.lngLat.lng > coordinatesActual[0] ? 360 : -360;
                }
                const activeCoordinatesArray = activeCoordinates !== undefined ? [activeCoordinates.lng, activeCoordinates.lat] : [0, 0];
                if (coordinates && !arraysAreEqual(coordinatesActual, activeCoordinatesArray)) {
                    let content = '';
                    const ele = coordinates.find(element => (estaContenido(element.lng, coordinatesActual[0], 0.0001) && estaContenido(element.lat, coordinatesActual[1], 0.0001)));
                    if (ele) {
                        if (ele.estado !== undefined) {
                            content += `<h6 style="margin: 0;">Pilona ${ele.description}</h6>`;
                        }
                        else if (ele.plazasLibres !== undefined) {
                            if (ele.plazasLibres === null) {
                                content += `<h6 style="margin: 0;">${ele.description}</h6>`;
                            } else {
                                content += `<h6 style="margin: 0;">${ele.description}</h6>`;
                            }
                        } else if (ele.fechaInicio !== undefined) {
                            content += `<h6 style="margin: 0;">Incidencia</h6>`;
                        } else {
                            content += `<h6 style="margin: 0;">Cámara ${ele.id}</h6>`;
                        }
                        popupContainer.innerHTML = content;
                        popupContainer.style.display = 'block';
                        popupContainer.style.backgroundColor = '#1f1f1f';
                        popupContainer.style.color = 'white';
                        popupContainer.style.borderRadius = '8px';
                        popupContainer.style.padding = '10px';
                        popupContainer.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.5)';

                    }
                }
            }
        }
    }
}
export async function mapClick(e, map, coordinates, apiUrlConfig, instance, showPopup, activeCoordinates) {
    if (e.features && e.features.length > 0) {
        const feature = e.features[0];
        if (feature.geometry.type === 'Point' && Array.isArray(feature.geometry.coordinates)) {
            const coordinatesActual = feature.geometry.coordinates.slice();
            while (Math.abs(e.lngLat.lng - coordinatesActual[0]) > 180) {
                coordinatesActual[0] += e.lngLat.lng > coordinatesActual[0] ? 360 : -360;
            }
            const activeCoordinatesArray = activeCoordinates !== undefined ? [activeCoordinates.lng, activeCoordinates.lat] : [0, 0];
            if (coordinates && !arraysAreEqual(coordinatesActual, activeCoordinatesArray)) {
                let content = '';
                const ele = coordinates.find(element => (estaContenido(element.lng, coordinatesActual[0], 0.0001) && estaContenido(element.lat, coordinatesActual[1], 0.0001)));
                if (ele) {
                    if (ele.plazasLibres !== undefined) {
                        if (ele.plazasLibres === null) {
                            content += `<h3>${ele.description}</h3>`;
                            content += `<p>${ele.direccion}</p>`;
                        } else {
                            content = ReactDOMServer.renderToString(
                                <PopUpAparcamiento
                                    description={ele.description}
                                    direccion={ele.direccion}
                                    plazasTotales={ele.plazasTotales}
                                    plazasLibres={ele.plazasLibres}
                                    nivel={ele.nivel}
                                    forzadura={ele.forzadura}
                                />
                            );
                        }
                    } else if (ele.fechaInicio !== undefined) {
                        const fechaFin = new Date(ele.fechaFin);
                        const fechaInicio = new Date(ele.fechaInicio);
                        const fechaActual = new Date();

                        const descripcion = (fechaActual >= fechaInicio && fechaActual <= fechaFin)
                            ? 'Incidencia'
                            : `Próxima Incidencia`;
                        content += `<h3>${descripcion}</h3>`;
                        content += `<p>${ele.description}</p>`;
                        content += `<p>${formatHora(ele.fechaInicio)} - ${formatHora(ele.fechaFin)}</p>`;
                    } else if (ele.estado !== undefined) {
                        content += `<h3 style="margin-top: 8px; margin-bottom: 3px; text-align: center;">Pilona ${ele.description}</h3>`;
                        content += `<p style="display: flex; justify-content: center; margin-top: 1px; margin-bottom: 1px;">${ObtenerEstadoPilona(ele.estado).nombre}</p>`;
                    } else {
                        const imageUrl = await fetchImage(ele.id, apiUrlConfig, instance);
                        if (imageUrl) {
                            content = ReactDOMServer.renderToString(
                                <PopUpCamara
                                    description={ele.description}
                                    id={ele.id}
                                    imageUrl={imageUrl}
                                />
                            );
                        } else {
                            content += `<p>Error loading image</p>`;
                        }
                    }
                }
                showPopup(coordinatesActual, content)
            }
        }
    }
}

export async function mapClickCluster(e, map, name) {
    const features = map.queryRenderedFeatures(e.point, {
        layers: [`clusters-${name}`]
    });
    const clusterId = features[0].properties.cluster_id;
    const placelocation = map.getSource(`${name}`)
    if (placelocation) {
        (placelocation).getClusterExpansionZoom(clusterId).then((zoom) => {
            map.easeTo({
                center: (features[0].geometry).coordinates,
                zoom: zoom
            });
        });
    }
}

export const addUnclusteredPointLayer = (map, layerId, source) => {
    map.addLayer({
      id: layerId,
      type: 'symbol',
      source: source,
      filter: ['!', ['has', 'point_count']],
      layout: {
        'icon-image': ['get', 'icon'],
        'icon-size': ['get', 'icon-size'],
        'icon-allow-overlap': true,
        'text-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-ignore-placement': true
      }
    });
  };

export const addClusterCountLayer = (map, layerId, source, textTranslate) => {
    map.addLayer({
      id: layerId,
      type: 'symbol',
      source: source,
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        "icon-padding": 0,
        "text-padding": 0,
        "text-overlap": "always",
        "icon-overlap": "always",
        "text-size": 9,
        "text-font": ["Roboto Bold", "Noto Bold"],
        "text-anchor": "center",
      },
      paint: {
        "text-color": "#ffffff",
        "text-translate": textTranslate,
      },
    });
  };

export const addClusterLayer = (map, layerId, source, iconImage, iconSize, iconTranslate, isCase = false) => {
    const layout = {
      'icon-image': isCase ? [
        'case',
        ['==', ['get', 'point_count'], ['get', 'plazasLibresCount']],
        'parking-cluster-red',
        iconImage
      ] : iconImage,
      'icon-size': iconSize,
      'icon-allow-overlap': true,
      'text-allow-overlap': true,
    };
  
    const paint = iconTranslate ? { "icon-translate": iconTranslate } : {};
  
    map.addLayer({
      id: layerId,
      type: 'symbol',
      source: source,
      filter: ['has', 'point_count'],
      layout: layout,
      paint: paint,
    });
  };

export const addGeoJsonSource = (map, sourceId, filterCondition, iconSize, isCluster, clusterProperties = {}) => {
    const features = filterCondition ? filterCondition.map(ele => ({
      'type': 'Feature',
      'properties': {
        'description': '<strong>Make it Mount Pleasant</strong>',
        'icon': ele.image,
        'icon-size': iconSize,
        ...('plazasLibres' in ele && { plazasLibres: ele.plazasLibres }) // Incluye plazasLibres si existe
      },
      'geometry': {
        'type': 'Point',
        'coordinates': [ele.lng, ele.lat]
      }
    })) : [];
  
    map.addSource(sourceId, {
      'type': 'geojson',
      'data': {
        'type': 'FeatureCollection',
        'features': features
      },
      cluster: isCluster,
      clusterMaxZoom: 16,
      clusterRadius: 50,
      ...isCluster && { clusterProperties } // Añade clusterProperties si es un clúster
    });
  };
